import React, { useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa'; // For the back arrow icon

const OtpPopup = ({ show, onClose, onVerify }) => {
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(true); // Simulate OTP sent status

  // Function to handle OTP submission
  const handleOtpSubmit = () => {
    // Placeholder for OTP verification logic
    if (otp === "123456") { // In a real scenario, verify with backend
      onVerify(true);
      onClose();
    } else {
      alert("Invalid OTP! Please try again.");
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <div className="bg-tertiary px-8 py-6 rounded-md lg:w-[40%] xl:w-[30%] z-40">
        
        {/* Header with back button and title */}
        <div className="flex items-center">
          {/* Back Button */}
          <button onClick={onClose} className="text-lg text-gray-600 mr-3">
            <FaArrowLeft />
          </button>

          {/* Title */}
          <h3 className="text-lg font-medium text-center flex-1">Verify Your E-mail</h3>
        </div>


        {/* Horizontal line */}
        <hr className="my-4" />

        {/* OTP Input Section */}
        <div className="mb-4 relative">
          <label htmlFor="otp" className="absolute text-base text-primary1 bg-tertiary left-3 top-3 px-2 transition-all duration-300 transform -translate-y-6">
            Enter OTP
          </label>
          <input
            id="otp"
            type="text"
            placeholder=" "
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="w-full px-4 py-2 border-2 rounded-md text-primary1 bg-tertiary focus:outline-none focus:ring-2 focus:ring-primary1"
          />
        </div>

        {/* OTP Sent Message */}
        {otpSent && (
          <p className="text-xs text-center text-gray-600 mt-2 mb-5">
           * We’ve sent an OTP to your e-mail address. Please enter the OTP to verify your e-mail address.
          </p>
        )}


        {/* Buttons */}
        <div className="">
         
          <button
            onClick={handleOtpSubmit}
            className="px-4 py-2 font-outfit font-medium text-lg hover:border-2 text-tertiary bg-hcolor w-full hover:text-hcolor hover:bg-tertiary"
          >
            VERIFY
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpPopup;
